import { load } from "recaptcha-v3";
import { RECAPTCHA_SITE_KEY } from "@/configs";

// The site key is a reCAPTCHA Enterprise key, so tokens must be minted through
// the Enterprise SDK. `useEnterprise: true` makes recaptcha-v3 load
// enterprise.js and route execute() through grecaptcha.enterprise.execute.
type RecaptchaInstance = Awaited<ReturnType<typeof load>>;

// Load the SDK once and reuse the promise across every submit.
let instancePromise: Promise<RecaptchaInstance> | null = null;

const getRecaptcha = (): Promise<RecaptchaInstance> => {
  if (!instancePromise) {
    instancePromise = load(RECAPTCHA_SITE_KEY, { useEnterprise: true }).catch(
      (error) => {
        instancePromise = null; // allow a retry on a later submit
        throw error;
      },
    );
  }
  return instancePromise;
};

// Mints a fresh, single-use token for the given action.
export const executeRecaptcha = async (action: string): Promise<string> => {
  const recaptcha = await getRecaptcha();
  return recaptcha.execute(action);
};
